import favHeart from "./modules/favHeart.js";
import filterWheelLive from "./modules/filterWheelLive.js";
import LiveRoulette26 from "./modules/liveRoulette26.js";
import lobbyGrid from "./modules/lobbyGrid.js";
import lobbyGridDraggable from "./modules/lobbyGridDraggable.js";
import slotsSliderCarousel from "./modules/slotsSliderCarousel.js";

document.addEventListener('DOMContentLoaded', () => {
  favHeart().init();
  filterWheelLive()
  LiveRoulette26();
  slotsSliderCarousel();
  document.querySelectorAll('.lobby-grid').forEach(grid => {
    lobbyGrid(grid);
  });
  document.querySelectorAll('.draggable-carousel').forEach(grid => {
    lobbyGridDraggable(grid);
  });
})
